// 导出 react-native-web 的所有组件和 API
import { Modal } from "react-native-web";
import { TouchableOpacity as RNTouchableOpacity, View } from "react-native-web";

export * from "react-native-web";
// react-native-web中没有StyleSheet，使用react-native的StyleSheet
export { StyleSheet, Keyboard, Platform } from "react-native";
export type {
  StyleProp,
  ViewStyle,
  TextStyle,
  ImageStyle,
  EmitterSubscription,
  FlexAlignType,
} from "react-native";
export const JSModal = Modal;

// 重新导出 TouchableOpacity 并添加 disabled 属性支持
export const TouchableOpacity = RNTouchableOpacity as React.ComponentType<
  React.ComponentProps<typeof RNTouchableOpacity> & {
    disabled?: boolean;
    onPress?: () => void;
  }
>;
// 键盘遮挡组件在Web中并不存在，为了非平台代码的正常编译。web需要替代导出
export const KeyboardAwareScrollView = View;
